import * as React from 'react';
import { usePlacesWidget } from "react-google-autocomplete";
import TextField from '@mui/material/TextField';

import "./searchbar.css";

const SearchBar = (props) => {

    const { ref: materialRef } = usePlacesWidget({
        
        apiKey:"AIzaSyDeTY_Gws7RWP_1M1VKcuNoNXSmcwSsfG0Y",
        
        onPlaceSelected: (place) => (
          props.setAddress(place.formatted_address),
          props.setCoordinates(JSON.parse(JSON.stringify(place.geometry?.location)))
        ),
        
        inputAutocompleteValue: "country",
        
        options: {
          componentRestrictions: {'country': ["us"]},
          types: ['address'] 
        },

    });

    return(
        
        <div>
           <TextField 
              id="bar" 
              placeholder="enter a home address"
              variant="outlined"
              inputRef={materialRef}
            />
        </div>
    )
};

export default SearchBar;